import React, { useState, useRef, useEffect } from 'react';
import { SearchIcon, DownArrowIcon } from '../../assets/svg';
import { useTheme } from '../../contexts/ThemeContext';
import CloseSVG from '../../assets/svg/CloseSVG';
import './CustomDropdownSearch.scss';

interface CustomDropdownSearchProps {
  options: any;
  className?: string;
  searchClassName?: string;
  searchValue?: string;
  searchPlaceholder?: string;
  searchStyle?: string;
  onSearchChange?: (value: string) => void;
  onSelectOption?: (option: any) => void;
  optionStyles?: string;
  isClose?: boolean;
  Hide?: () => void;
  isLoading?: boolean
}

const CustomDropdownSearch: React.FC<CustomDropdownSearchProps> = ({
    options,
    className,
    searchClassName,
    searchValue,
    searchPlaceholder,
    onSearchChange,
    onSelectOption,
    searchStyle,
    optionStyles,
    isClose,
    Hide,
    isLoading = false
 }) => {
  const [selectedOption, setSelectedOption] = useState<any>(options[0]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const selectRef = useRef<HTMLDivElement | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const { darkTheme } = useTheme();

  const handleClickOutside = (event: MouseEvent) => {
    if (selectRef.current && !selectRef.current.contains(event.target as Node) && !isLoading) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleOptionClick = (option: any) => {
    setSelectedOption(option);
    setIsOpen(false);
    if (onSelectOption) {
      onSelectOption(option);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (onSearchChange) {
      onSearchChange(value);
    }
  };

  return (
    <div className={`custom-search-bar ${searchStyle} ${className}`} ref={selectRef}>
      <div className={`search_box ${className}`}>
        <div className={`dropdown ${isOpen ? 'open' : ''} ${optionStyles}`}>
          <div className={`default_option ${className}`} onClick={() => setIsOpen(!isOpen)}>
            {selectedOption?.label}
            <DownArrowIcon color={darkTheme? '#FFFFFF' : '#454545'} />
          </div>
          {isOpen && (
            <ul className={className}>
              {options.map((option: any, index: number) => (
                <li key={index} onClick={() => handleOptionClick(option)}>{option.label}</li>
              ))}
            </ul>
          )}
        </div>
        <div className={`search_field ${className}`}>
          <input
            type="text"
            className={`input ${searchClassName}`}
            placeholder={searchPlaceholder}
            value={searchValue}
            ref={inputRef}
            onChange={handleInputChange}
          />
          <SearchIcon />
          {isClose && (
            <div onClick={Hide} className="close-icon">
              <CloseSVG />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomDropdownSearch;
